<template>
  <div class="chatroom-filter">
    <div>
      <div style="display: flex;justify-content: space-between;align-items: center">
        <h3> 群标签 </h3>
        <a-button type='primary' htmlType='submit' style="margin-bottom: 10px;" @click="editTags">
          {{ buttonText }}
        </a-button>
      </div>
      <a-list
        column="1"
        bordered
        split
        :data-source="category_list"
        style="margin-bottom: 10px"
      >
        <a-list-item @drop="onDrop($event, item)" @dragover="onDragOver" class="tag-list" slot="renderItem" slot-scope="item, index" :key="item.id">
          <span style="margin-bottom: 5px; margin-top: 5px; margin-right: 10px"> {{ item.category_name + '(' + item.total_count + ')' }}: </span>
          <TagList
            v-on:on-tag-change="onTagChange"
            :oriTagList="item.tag_list"
            :checkable="tagsCheckable"
            :newable="tagsNewable"
            :draggable="true"
            :category_id="item.id"
            v-on:on-delete-tag="(tagIndex) => onDeleteTag(tagIndex, item)"
          />
        </a-list-item>
      </a-list>
    </div>
    <div class="chatroom-search">
      <a-form layout='inline' @submit="handleSubmit" :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item label='群名'>
          <a-input placeholder="群名" v-model="filter.searchChatroomNickname">
            <a-icon slot="prefix" type="usergroup-add"/>
          </a-input>
        </a-form-item>
        <a-form-item label='群主昵称'>
          <a-input placeholder="微信群的真正群主" v-model="filter.searchOwnerNickname">
            <a-icon slot="prefix" type="wechat"/>
          </a-input>
        </a-form-item>
        <a-form-item label='群主微信名'>
          <a-input placeholder="微信群的真正群主" v-model="filter.searchOwnerUsername">
            <a-icon slot="prefix" type="wechat"/>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type='primary' htmlType='submit'>
            搜索
          </a-button>
          <a-button type='primary' style="margin-left: 40px;" @click="openDialog">
            换群数据
          </a-button>
          <a-modal v-model="dialogVisible" title="换群数据" @ok="handleOk">
            <div>
              <div style="display: flex; width: 80%; align-items: center">
                <div style="margin-right: 20px; flex: 1;">client_id</div>
                <a-input v-model="clientId" style="width: 300px;" />
              </div>
              <div style="display: flex; width: 80%; align-items: center; margin-top: 20px;">
                <div style="margin-right: 20px; flex: 1;">旧群id</div>
                <a-input v-model="oldChatroom" style="width: 300px;" />
              </div>
              <div style="display: flex; width: 80%; align-items: center; margin-top: 20px;">
                <div style="margin-right: 20px; flex: 1;">新群id</div>
                <a-input v-model="newChatroom" style="width: 300px;" />
              </div>
            </div>
          </a-modal>
        </a-form-item>
      </a-form>
      <!--<TagList-->
        <!--v-if="filter.selectedTagList.length > 0"-->
        <!--v-on:on-tag-close="onTagClose"-->
        <!--:oriTagList="filter.selectedTagList"-->
        <!--:closable="true"/>-->
    </div>
  </div>
</template>

<script>
import '../config/global'
import TagList from './TagList'
import AButton from 'ant-design-vue/es/button/button'
const axios = require('axios')
export default {
  name: 'ChatroomFilter',
  props: ['groups', 'levels', 'categories'],
  components: {AButton, TagList},
  data () {
    return {
      editTagUrlPostfix: 'edit_tag',
      filter: {
        selectedTagList: [],
        searchChatroomNickname: '',
        searchOwnerNickname: '',
        searchOwnerUsername: ''
      },
      category_list: this.categories || [],
      tagsNewable: false,
      tagsCheckable: true,
      // tagsClosable: true, //暂时不提供顶部过滤器的删除
      buttonText: '编辑',
      dialogVisible: false,
      clientId: undefined,
      oldChatroom: undefined,
      newChatroom: undefined
    }
  },
  watch: {
    categories: function (newValue, oldValue) {
      // console.log('group change', newValue, oldValue)
      this.category_list = []
      this.categories.forEach((category) => {
        this.category_list.push(category)
      })
      // console.log('columns', this.columns)
    }
  },
  computed: {
    editTagUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.editTagUrlPostfix
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      console.log('searchChatroomNickname: ' + this.filter.searchChatroomNickname.trim())
      console.log('searchOwnerNickname: ' + this.filter.searchOwnerNickname.trim())
      console.log('searchOwnerUsername: ' + this.filter.searchOwnerUsername.trim())
      if (this.filter.searchChatroomNickname.trim() || this.filter.searchOwnerNickname.trim() || this.filter.searchOwnerUsername.trim()) {
        this.handleSearch()
      }
    },
    handleSearch () {
      // console.log('handleSearch')
      this.$emit('on-search', this.filter)
    },
    // onTagAdd (newTag) {
    //   console.log('onTagAdd')
    //   const categoryId = newTag.category_id
    //   const categoryList = [...this.category_list]
    //   const category = categoryList.find(item => item.category_id === categoryId)
    //   if (category) {
    //     category.push(newTag)
    //   }
    // },
    onTagChange (tagChange, checked) {
      // console.log('onTagChange')
      tagChange.checked = checked
      const { selectedTagList } = this.filter
      if (checked) {
        let isDup = selectedTagList.some((selectedTag) => {
          return tagChange.id === selectedTag.id
        })
        if (!isDup) {
          this.filter.selectedTagList.push(tagChange)
        }
      } else {
        this.filter.selectedTagList = selectedTagList.filter(t => t.id !== tagChange.id)
      }
      // let tagIndexTmp = this.filter.selectedTagList.indexOf(tagChange.value)
      // console.log(tagIndexTmp)
      // if (checked && tagIndexTmp === -1) {
      //   this.filter.selectedTagList.push(tagChange.value)
      // } else if (!checked && tagIndexTmp !== -1) {
      //   this.filter.selectedTagList.splice(tagIndexTmp, 1)
      // }
      // console.log(this.filter.selectedTagList)
      this.handleSearch()
    },
    onDragOver (e) {
      // console.log('onDragOver', e)
      e.preventDefault()
    },
    onDrop (e, category) {
      console.log('onDrop', e, category)
      const tagId = e.dataTransfer.getData('tag_id')
      const tagName = e.dataTransfer.getData('tag_name')
      console.log('onDrop', tagId)
      console.log('onDrop', tagName)
      axios.post(this.editTagUrl, {
        tag_id: tagId,
        category_id: category.id,
        token: sessionStorage.token
      })
        .then((data) => {
          // console.log(data.data)
          // console.log('data.err_code: ' + data.data.err_code)
          if (data.data.err_code === 0) {
            const newTag = data.data.content.tag
            category.tag_list.push(newTag)
            category.total_count += 1
            console.log(category)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    onDeleteTag (tagIndex, category) {
      console.log('onDeleteTag', tagIndex)
      category.tag_list.splice(tagIndex, 1)
      category.total_count -= 1
    },
    editTags () {
      // console.log('editTags', this.tagsCheckable)
      this.tagsCheckable = !this.tagsCheckable
      this.tagsNewable = !this.tagsNewable
      this.buttonText = this.tagsCheckable ? '编辑' : '完成'
    },

    openDialog () {
      this.dialogVisible = true
    },

    handleOk () {
      axios.post(global.DOMAIN + global.API_VERSION + 'uchatroom/change_chatroom_data', {
        token: sessionStorage.token,
        client_id: +this.clientId,
        old_chatroom: this.oldChatroom,
        new_chatroom: this.newChatroom
      }).then(res => {
        if (res.data.err_code === 0) {
          this.$message.success('成功')
          this.dialogVisible = false
        }
      })
    }
  }
}
</script>
